import type { LayoutSections } from '@teemill/modules/app';

export const mailConfig: LayoutSections = {
  announcement: false,
  header: {
    show: true,
    overlay: true,
    fixed: true,
    height: '4rem',
    width: '100%',
    logo: true,
    logoMaxWidth: '220px',
    centerLogo: false,
    content: true,
  },
  sidebar: false,
  content: {
    show: true,
    head: true,
    width: '520px',
  },
  footer: false,
  subFooter: false,
  navBar: false,
};
